(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elliot-landing"]) return;
  try {
    
document.querySelectorAll('.elliot-lp .faq-question').forEach(function (b) {
  b.addEventListener('click', function () {
    b.parentElement.classList.toggle('open');
  });
});
var firstElliotFaq = document.querySelector('.elliot-lp .faq-item');
if (firstElliotFaq) { firstElliotFaq.classList.add('open'); }

window.dataLayer = window.dataLayer || [];
document.querySelectorAll('.elliot-lp .buy-card').forEach(function (el) {
  el.addEventListener('click', function () {
    var node = el.querySelector('.buy-title');
    var name = node ? node.textContent : 'unknown';
    window.dataLayer.push({ event: 'product_click', product_name: name.trim(), page_type: 'elliot_landing' });
  });
});
document.querySelectorAll('.elliot-lp a[href^="tel:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'phone_click', page_type: 'elliot_landing' });
  });
});
document.querySelectorAll('.elliot-lp a[href^="mailto:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'email_click', page_type: 'elliot_landing' });
  });
});
var elliotFired = {};
window.addEventListener('scroll', function () {
  var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
  if (pct >= 50 && !elliotFired.s50) { elliotFired.s50 = true; window.dataLayer.push({ event: 'scroll_50', page_type: 'elliot_landing' }); }
  if (pct >= 90 && !elliotFired.s90) { elliotFired.s90 = true; window.dataLayer.push({ event: 'scroll_90', page_type: 'elliot_landing' }); }
}, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laerdal-landing"]) return;
  try {
    
(function () {
  // Section javascript blocks are concatenated into the theme-wide bundle and
  // run on every page of the store - bail unless this section is rendered.
  if (!document.querySelector('.laerdal-lp')) return;

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.style.scrollBehavior = 'smooth';
  }

  document.querySelectorAll('.laerdal-lp .faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var open = item.classList.contains('open');
      document.querySelectorAll('.laerdal-lp .faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!open) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  window.dataLayer = window.dataLayer || [];
  // Bind to the navigating links, not the whole card - cards are not clickable,
  // so card-level binding would report clicks that never reach a product page.
  document.querySelectorAll('.laerdal-lp .product-card a, .laerdal-lp .diversity-card a, .laerdal-lp .re-item a').forEach(function (link) {
    link.addEventListener('click', function () {
      var card = link.closest('[data-product-name]');
      var name = card ? card.getAttribute('data-product-name') : 'unknown';
      window.dataLayer.push({ event: 'product_click', product_name: name.trim(), page_type: 'laerdal_landing' });
    });
  });
  document.querySelectorAll('.laerdal-lp a[href^="tel:"]').forEach(function (el) {
    el.addEventListener('click', function () {
      window.dataLayer.push({ event: 'bulk_phone_click', page_type: 'laerdal_landing' });
    });
  });
  document.querySelectorAll('.laerdal-lp a[href^="mailto:"]').forEach(function (el) {
    el.addEventListener('click', function () {
      window.dataLayer.push({ event: 'bulk_email_click', page_type: 'laerdal_landing' });
    });
  });

  var fired = {};
  window.addEventListener('scroll', function () {
    var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
    if (pct >= 50 && !fired.s50) { fired.s50 = true; window.dataLayer.push({ event: 'scroll_50', page_type: 'laerdal_landing' }); }
    if (pct >= 90 && !fired.s90) { fired.s90 = true; window.dataLayer.push({ event: 'scroll_90', page_type: 'laerdal_landing' }); }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philips-landing"]) return;
  try {
    
(function () {
  // Section javascript blocks are concatenated into the theme-wide bundle and
  // run on every page of the store - bail unless this section is rendered.
  if (!document.querySelector('.philips-lp')) return;

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.style.scrollBehavior = 'smooth';
  }

  document.querySelectorAll('.philips-lp .faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var open = item.classList.contains('open');
      document.querySelectorAll('.philips-lp .faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!open) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  window.dataLayer = window.dataLayer || [];
  // Bind to the navigating links, not the whole card - cards are not clickable,
  // so card-level binding would report clicks that never reach a product page.
  document.querySelectorAll('.philips-lp .product-card a, .philips-lp .re-item a, .philips-lp .verdict a').forEach(function (link) {
    link.addEventListener('click', function () {
      var card = link.closest('[data-product-name]');
      var name = card ? card.getAttribute('data-product-name') : link.textContent;
      window.dataLayer.push({ event: 'product_click', product_name: name.trim(), page_type: 'philips_landing' });
    });
  });
  document.querySelectorAll('.philips-lp a[href^="tel:"]').forEach(function (el) {
    el.addEventListener('click', function () {
      window.dataLayer.push({ event: 'bulk_phone_click', page_type: 'philips_landing' });
    });
  });
  document.querySelectorAll('.philips-lp a[href^="mailto:"]').forEach(function (el) {
    el.addEventListener('click', function () {
      window.dataLayer.push({ event: 'bulk_email_click', page_type: 'philips_landing' });
    });
  });

  var fired = {};
  window.addEventListener('scroll', function () {
    var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
    if (pct >= 50 && !fired.s50) { fired.s50 = true; window.dataLayer.push({ event: 'scroll_50', page_type: 'philips_landing' }); }
    if (pct >= 90 && !fired.s90) { fired.s90 = true; window.dataLayer.push({ event: 'scroll_90', page_type: 'philips_landing' }); }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestan-landing"]) return;
  try {
    
document.querySelectorAll('.prestan-lp .faq-question').forEach(function (b) {
  b.addEventListener('click', function () {
    b.parentElement.classList.toggle('open');
  });
});
var firstFaq = document.querySelector('.prestan-lp .faq-item');
if (firstFaq) { firstFaq.classList.add('open'); }

window.dataLayer = window.dataLayer || [];
document.querySelectorAll('.prestan-lp .product-card, .prestan-lp .diversity-card, .prestan-lp .reorder-item').forEach(function (el) {
  el.addEventListener('click', function () {
    var name = el.getAttribute('data-product-name');
    if (!name) {
      var node = el.querySelector('.product-title, h4, .reorder-item-name');
      name = node ? node.textContent : 'unknown';
    }
    window.dataLayer.push({ event: 'product_click', product_name: name.trim(), page_type: 'prestan_landing' });
  });
});
document.querySelectorAll('.prestan-lp a[href^="tel:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'bulk_phone_click', page_type: 'prestan_landing' });
  });
});
document.querySelectorAll('.prestan-lp a[href^="mailto:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'bulk_email_click', page_type: 'prestan_landing' });
  });
});
var fired = {};
window.addEventListener('scroll', function () {
  var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
  if (pct >= 50 && !fired.s50) { fired.s50 = true; window.dataLayer.push({ event: 'scroll_50', page_type: 'prestan_landing' }); }
  if (pct >= 90 && !fired.s90) { fired.s90 = true; window.dataLayer.push({ event: 'scroll_90', page_type: 'prestan_landing' }); }
}, { passive: true });

  } catch(e) { console.error(e); }
})();
})();
